/**
 * @generated SignedSource<<2cad8bdb5f32ffeb9e17313e38518d7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SnsAssociationYoutube$data = {
  readonly profile: {
    readonly ytChannel: string | null;
  };
  readonly " $fragmentType": "SnsAssociationYoutube";
};
export type SnsAssociationYoutube$key = {
  readonly " $data"?: SnsAssociationYoutube$data;
  readonly " $fragmentSpreads": FragmentRefs<"SnsAssociationYoutube">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SnsAssociationYoutube",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ytChannel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "04c14db117b7fd7c186b04ad12e71545";

export default node;
